/* ==========================================================================
   LIVADUR – Lieferengpass-Gate
   Gehört zu snippets/DTA-livadur-gate.liquid.

   Drei Aufgaben:
   1. Doppelte Klaviyo-Formulare entschärfen. Dasselbe Embed-Formular rendert
      pro Seite nur einmal zuverlässig — kommt es mehrfach vor (z.B. Bundle-
      Promotion und Produktkachel auf derselben Collection-Seite), behält das
      erste Vorkommen Formular, Dankeschön und Alternative; alle weiteren
      behalten nur den Hinweis.
   2. Links ausblenden, die auf die Seite zeigen, auf der man schon steht.
   3. Rabattcode per Klick in die Zwischenablage kopieren.
   ========================================================================== */
(function () {
  'use strict';

  /* Mehrere Gates auf einer Seite (z.B. Bundle-PDP: Kaufbox UND Bundle-Promotion):
     nur das erste behält Formular, Dankeschön und Alternative. Alle weiteren
     zeigen den Hinweis und einen Link — sonst stünden Code-Chip und
     Gratis-Zusage mehrfach auf derselben Seite. */
  function dedupeForms() {
    var forms = document.querySelectorAll('[data-dta-lgate-form]');
    if (forms.length < 2) return;

    for (var i = 1; i < forms.length; i++) {
      var form = forms[i];
      if (form.dataset.lgateDeduped === '1') continue;
      form.dataset.lgateDeduped = '1';

      var gate = form.closest('[data-dta-lgate]');
      var embed = form.querySelector('[data-dta-lgate-embed]');
      var heading = form.querySelector('.dta-lgate__form-heading');
      var fallback = form.querySelector('.dta-lgate__fallback');

      /* Entfernen statt verstecken: ein nur ausgeblendetes Formular würde
         Klaviyo trotzdem als Treffer zählen und das sichtbare leer lassen. */
      if (embed) embed.remove();
      if (heading) heading.remove();
      if (gate) {
        var gift = gate.querySelector('.dta-lgate__gift');
        var alt = gate.querySelector('.dta-lgate__alt');
        if (gift) gift.remove();
        if (alt) alt.remove();
      }

      /* Der Link zeigt auf die Produktseite. Sind wir schon dort, wäre er
         sinnlos — das Formular steht ja weiter oben auf derselben Seite.
         Dann bleibt nur der Hinweis stehen. */
      if (fallback && fallback.pathname !== window.location.pathname) {
        fallback.removeAttribute('hidden');
      }
    }
  }

  /* Ein Link auf die Seite, auf der man schon steht, hilft niemandem. Betrifft
     den Link-Modus in Sections, die auf ihrer eigenen Produktseite sitzen —
     etwa die Bundle-Promotion auf der Bundle-PDP, wo das Formular ohnehin
     schon in der Kaufbox darüber steht. Dann bleibt nur der Hinweis. */
  function hideSelfLinks() {
    var wrappers = document.querySelectorAll('[data-dta-lgate-link]');
    for (var i = 0; i < wrappers.length; i++) {
      var link = wrappers[i].querySelector('a[href]');
      if (link && link.pathname === window.location.pathname) {
        wrappers[i].hidden = true;
      }
    }
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      }
      document.body.removeChild(ta);
    });
  }

  /* Text im Chip weich austauschen: erst ausblenden, dann tauschen, dann wieder ein. */
  function fadeSwap(el, text) {
    el.style.opacity = '0';
    setTimeout(function () {
      el.textContent = text;
      el.style.opacity = '1';
    }, 150);
  }

  function handleCopy(chip) {
    var code = chip.getAttribute('data-code');
    var value = chip.querySelector('[data-dta-lgate-code-value]');
    if (!code || !value) return;

    if (chip.dataset.lgateBusy === '1') return;
    chip.dataset.lgateBusy = '1';

    /* Ausgangsbreite einfrieren, sonst springt der Chip beim Textwechsel. */
    if (!value.style.minWidth) {
      value.style.minWidth = Math.ceil(value.getBoundingClientRect().width) + 'px';
    }

    copyText(code).then(function () {
      chip.classList.add('is-copied');
      fadeSwap(value, chip.getAttribute('data-copied') || 'Kopiert!');
    }).catch(function () {
      /* Kein Clipboard-Zugriff (z.B. iOS ohne Nutzergeste): Code markieren,
         damit der Kunde ihn selbst kopieren kann. Dann auch kein "Kopiert!". */
      var range = document.createRange();
      range.selectNodeContents(value);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      chip.dataset.lgateFailed = '1';
    }).then(function () {
      if (chip.dataset.lgateFailed === '1') {
        chip.dataset.lgateFailed = '0';
        chip.dataset.lgateBusy = '0';
        return;
      }
      setTimeout(function () {
        chip.classList.remove('is-copied');
        fadeSwap(value, code);
        chip.dataset.lgateBusy = '0';
      }, 1400);
    });
  }

  /* Alternative-Button: Code per Ajax in den Warenkorb legen. Der Link selbst
     zeigt direkt auf die Produktseite mit Variante — so funktioniert er auch
     ohne JS, im Theme-Editor und auf dem lokalen Dev-Server, wo die
     /discount/-Route von Shopify nicht greift.
     Die Navigation wird bewusst NICHT angehalten: andere Theme-Skripte fangen
     Link-Klicks ab (preventDefault + eigene Navigation, Propagation gestoppt),
     ein Warten auf die Antwort wäre also unzuverlässig. Stattdessen läuft der
     Request mit keepalive weiter, auch wenn die Seite schon wechselt — der
     Code liegt serverseitig im Warenkorb, bevor der Kunde im Checkout ist. */
  function applyCode(code) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).catch(function () {});
    } catch (err) {
      /* Kein fetch (sehr alte Browser): der Chip bleibt als Fallback. */
    }
  }

  /* Läuft in der Capture-Phase, damit kein anderes Skript den Klick vorher
     per stopPropagation verschluckt. */
  function onClickCapture(e) {
    if (!e.target.closest) return;
    var altLink = e.target.closest('[data-dta-lgate-alt][data-apply-code] a[href]');
    if (!altLink) return;
    var code = altLink.closest('[data-dta-lgate-alt]').getAttribute('data-apply-code');
    if (code) applyCode(code);
  }

  function onClick(e) {
    if (!e.target.closest) return;

    var chip = e.target.closest('[data-dta-lgate-code]');
    if (!chip) return;
    e.preventDefault();
    handleCopy(chip);
  }

  function onKey(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var chip = e.target.closest ? e.target.closest('[data-dta-lgate-code]') : null;
    if (!chip) return;
    e.preventDefault();
    handleCopy(chip);
  }

  function init() {
    dedupeForms();
    hideSelfLinks();
    if (document.documentElement.dataset.lgateBound === '1') return;
    document.documentElement.dataset.lgateBound = '1';
    document.addEventListener('click', onClickCapture, true);
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
  }

  /* Möglichst früh laufen, damit die Dubletten weg sind, bevor Klaviyo scannt. */
  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
